import React from "react";

import classnames from "classnames";

export const CurrentServer = (props: {
	serve: "home" | "away" | undefined;
}) => {
	const offerScoreServerClassNames = classnames(
		"offer__score__col offer__score__server",
		{
			// @ts-expect-error
			"is-empty": props.serve == null || props.serve === "",
		}
	);

	return (
		<div className={offerScoreServerClassNames}>
			<div className="offer__score__item">
				{props.serve === "home" && <ServeIcon />}
			</div>
			<div className="offer__score__item">
				{props.serve === "away" && <ServeIcon />}
			</div>
		</div>
	);
};

function ServeIcon() {
	return <i className="offer__score__serve" />;
}
